import { render, staticRenderFns } from "./EditDimension.vue?vue&type=template&id=47214fd2&"
import script from "./EditDimension.vue?vue&type=script&lang=js&"
export * from "./EditDimension.vue?vue&type=script&lang=js&"
import style0 from "./EditDimension.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports